import { format } from "@hejdoktor/resx-compiler"
export { format }
import { getLocale } from "@hejdoktor/resx-compiler"

import { R as _da } from "./EnumResources.da.resx"
import { R as _en } from "./EnumResources.en.resx"
import { R as _no } from "./EnumResources.no.resx"

type Translations = {
	"Name1": string,
	"Bitmap1": string,
	"Icon1": string,
	"CaregiverRoleEnum_AllergyDoctor": string,
	"CaregiverRoleEnum_Dentist": string,
	"CaregiverRoleEnum_Dermatologist": string,
	"CaregiverRoleEnum_Doctor": string,
	"CaregiverRoleEnum_Midwife": string,
	"CaregiverRoleEnum_Nurse": string,
	"CaregiverRoleEnum_Physiotherapist": string,
	"CaregiverRoleEnum_Psychologist": string,
	"CaregiverRoleEnum_Rheumatologist": string,
	"CaregiverRoleEnum_SundVaegtDoctor": string,
	"CaregiverRoleEnum_SundVaegtNurse": string,
	"CaregiverRoleEnum_Dietitian": string,
	"CaregiverRoleEnum_AcneDermatologist": string,
	"CaregiverRoleEnum_Veterinarian": string,
	"CaregiverRoleEnum_AllergyDoctor_Indefinite": string,
	"CaregiverRoleEnum_Dentist_Indefinite": string,
	"CaregiverRoleEnum_Dermatologist_Indefinite": string,
	"CaregiverRoleEnum_Doctor_Indefinite": string,
	"CaregiverRoleEnum_Midwife_Indefinite": string,
	"CaregiverRoleEnum_Nurse_Indefinite": string,
	"CaregiverRoleEnum_Physiotherapist_Indefinite": string,
	"CaregiverRoleEnum_Psychologist_Indefinite": string,
	"CaregiverRoleEnum_Rheumatologist_Indefinite": string,
	"CaregiverRoleEnum_SundVaegtDoctor_Indefinite": string,
	"CaregiverRoleEnum_SundVaegtNurse_Indefinite": string,
	"CaregiverRoleEnum_Dietitian_Indefinite": string,
	"CaregiverRoleEnum_AcneDermatologist_Indefinite": string,
	"CaregiverRoleEnum_Veterinarian_Indefinite": string,
	"ConsultationPaymentProviderEnum_ApplePay": string,
	"ConsultationPaymentProviderEnum_Company": string,
	"ConsultationPaymentProviderEnum_Coupon": string,
	"ConsultationPaymentProviderEnum_DIBS": string,
	"ConsultationPaymentProviderEnum_ePay": string,
	"ConsultationPaymentProviderEnum_GoogleWallet": string,
	"ConsultationPaymentProviderEnum_GracePeriod": string,
	"ConsultationPaymentProviderEnum_ReepayCheckout": string,
	"ConsultationPaymentProviderEnum_Repay": string,
	"ConsultationPaymentProviderEnum_Subscription": string,
	"ConsultationPaymentProviderEnum_PriceOverride": string,
	"ConsultationTypeEnum_AllergyCheckVideo": string,
	"ConsultationTypeEnum_DentistMessage": string,
	"ConsultationTypeEnum_DentistVideo": string,
	"ConsultationTypeEnum_DermatologistMessage": string,
	"ConsultationTypeEnum_DermatologistVideo": string,
	"ConsultationTypeEnum_Message": string,
	"ConsultationTypeEnum_MidwifeMessage": string,
	"ConsultationTypeEnum_MidwifeVideo": string,
	"ConsultationTypeEnum_NurseMessage": string,
	"ConsultationTypeEnum_NurseVideo": string,
	"ConsultationTypeEnum_PhysiotherapistStartupVideo": string,
	"ConsultationTypeEnum_PhysiotherapistMessage": string,
	"ConsultationTypeEnum_Prescription": string,
	"ConsultationTypeEnum_PsychologistVideo": string,
	"ConsultationTypeEnum_PsychologistCrisisVideo": string,
	"ConsultationTypeEnum_RheumatologistVideo": string,
	"ConsultationTypeEnum_SundVaegtStartupMessage": string,
	"ConsultationTypeEnum_SundVaegtNurseCheckupVideo": string,
	"ConsultationTypeEnum_Video": string,
	"ConsultationTypeEnum_DietitianStartupVideo": string,
	"PlanInterval_Day": string,
	"PlanInterval_Month": string,
	"PlanInterval_Week": string,
	"PlanInterval_Year": string,
	"ServiceTypeEnum_AllergyCheck": string,
	"ServiceTypeEnum_DermatologistMessage": string,
	"ServiceTypeEnum_DermatologistMessageReply": string,
	"ServiceTypeEnum_DermatologistVideo": string,
	"ServiceTypeEnum_Message": string,
	"ServiceTypeEnum_MessageReply": string,
	"ServiceTypeEnum_PhysiotherapistStartupVideo": string,
	"ServiceTypeEnum_PhysiotherapistMessage": string,
	"ServiceTypeEnum_PhysiotherapistMessageReply": string,
	"ServiceTypeEnum_Prescription": string,
	"ServiceTypeEnum_PsychologistVideo": string,
	"ServiceTypeEnum_PsychologistCrisisVideo": string,
	"ServiceTypeEnum_RheumatologistVideo": string,
	"ServiceTypeEnum_SundVaegtStartupMessage": string,
	"ServiceTypeEnum_VideoConsultation": string,
	"ServiceTypeEnum_AllergyCheckVideo": string,
	"ServiceTypeEnum_DietitianStartupVideo": string,
	"UserTypeEnum_Admin": string,
	"UserTypeEnum_Doctor": string,
	"UserTypeEnum_Patient": string,
	"ConsultationTypeEnum_SundVaegtDoctorCheckupVideo": string,
	"ServiceTypeEnum_SundVaegtDoctorCheckupVideo": string,
	"ServiceTypeEnum_SundVaegtNurseCheckupVideo": string,
	"ConsultationTypeEnum_SundVaegtNurseCheckupMessage": string,
	"ServiceTypeEnum_SundVaegtNurseCheckupMessage": string,
	"ServiceTypeEnum_SundVaegtNurseCheckupMessageReply": string,
	"ServiceTypeEnum_SundVaegtQuestionnaireMessageReply": string,
	"ConsultationTypeEnum_SundVaegtNurseAdHocVideo": string,
	"ServiceTypeEnum_SundVaegtNurseAdHocVideo": string,
	"ConsultationTypeEnum_SundVaegtQuestionnaireMessage": string,
	"ServiceTypeEnum_SundVaegtQuestionnaireMessage": string,
	"ConsultationTypeEnum_PhysiotherapistCheckupVideo": string,
	"ServiceTypeEnum_PhysiotherapistCheckupVideo": string,
	"ConsultationTypeEnum_PhysiotherapistQuestionnaireMessage": string,
	"ServiceTypeEnum_PhysiotherapistQuestionnaireMessage": string,
	"ServiceTypeEnum_SundVaegtStartupMessageReply": string,
	"SubscriptionStatusEnum_Active": string,
	"SubscriptionStatusEnum_Canceled": string,
	"SubscriptionStatusEnum_Expired": string,
	"SubscriptionStatusEnum_PastDue": string,
	"SubscriptionStatusEnum_Trialing": string,
	"SubscriptionStatusEnum_Unknown": string,
	"ConsultationTypeEnum_DietitianCheckupVideo": string,
	"ServiceTypeEnum_DietitianCheckupVideo": string,
	"ConsultationTypeEnum_DietitianUploadAttachmentMessage": string,
	"ServiceTypeEnum_DietitianUploadAttachmentMessage": string,
	"ServiceTypeEnum_DietitianVideo": string,
	"AllergyCheckVideo": string,
	"ConsultationTypeEnum_AllergyCheck": string,
	"ConsultationTypeEnum_PersonalHealthProgrammeStartup": string,
	"ServiceTypeEnum_PersonalHealthProgrammeStartup": string,
	"ConsultationTypeEnum_AcneProgrammeStartupMessage": string,
	"ConsultationTypeEnum_AcneProgrammeStartupVideo": string,
	"ConsultationTypeEnum_AcneProgrammeCheckupVideo": string,
	"ServiceTypeEnum_AcneProgrammeStartupMessage": string,
	"ServiceTypeEnum_AcneProgrammeStartupVideo": string,
	"ServiceTypeEnum_AcneProgrammeCheckupVideo": string,
	"ConsultationTypeEnum_AcneDermatologistMessage": string,
	"ServiceTypeEnum_AcneDermatologistMessage": string,
	"ServiceTypeEnum_AcneDermatologistMessageReply": string,
	"ServiceTypeEnum_VeterinarianVideo": string,
	"ConsultationPaymentProviderEnum_Free": string,
	"ConsultationTypeEnum_VeterinarianVideo": string,
	"PetSex_Female": string,
	"PetSex_FemaleSterilized": string,
	"PetSex_Male": string,
	"PetSex_MaleNeutered": string,
	"PetSex_Unknown": string,
	"PetType_Dog": string,
	"PetType_Cat": string,
	"PetType_Rabbit": string,
	"PetType_Rodent": string,
	"VetConsultationReasonEnum_Gastrointestinal": string,
	"VetConsultationReasonEnum_SkinCoatEars": string,
	"VetConsultationReasonEnum_Poisoning": string,
	"VetConsultationReasonEnum_Eyes": string,
	"VetConsultationReasonEnum_UrinaryTract": string,
	"VetConsultationReasonEnum_Lameness": string,
	"VetConsultationReasonEnum_RespiratoryTract": string,
	"VetConsultationReasonEnum_OralCavity": string,
	"VetConsultationReasonEnum_Pain": string,
	"VetConsultationReasonEnum_Claws": string,
	"VetConsultationReasonEnum_GenitalsMammaryGlands": string,
	"VetConsultationReasonEnum_ReproductionCycle": string,
	"VetConsultationReasonEnum_Behaviour": string,
	"VetConsultationReasonEnum_Prescription": string,
	"VetConsultationReasonEnum_OtherReason": string,
	"VetConsultationOutcomeEnum_AdvisedForHomeTreatment": string,
	"VetConsultationOutcomeEnum_ReferredDuringRegularOpeningHours": string,
	"VetConsultationOutcomeEnum_ReferredOutsideRegularOpeningHours": string,
}

const R = new Proxy({}, {
	get(target, name: keyof Translations, receiver) {
		if(process.env.enforcedLocale === "da" || (!process.env.enforcedLocale && getLocale("da") === "da")) {
			return _da[name] ?? name
		}

if(process.env.enforcedLocale === "en" || (!process.env.enforcedLocale && getLocale("da") === "en")) {
			return _en[name] ?? name
		}

if(process.env.enforcedLocale === "no" || (!process.env.enforcedLocale && getLocale("da") === "no")) {
			return _no[name] ?? name
		}

		return name
	},
}) as Translations

export { R }